module.exports = __webpack_public_path__ + "img/solution1.2b2f96e0.png";